import styled from 'styled-components'
import { grid } from '../../styles/vars/grid.style'
import { clamp, getClampValue } from '../../styles/utils/conversion.style'
import { breakpoints } from '../../styles/vars/breakpoints.style'
import { mq } from '../../styles/vars/media-queries.style'
import { CarouselItemMain } from '../CarouselItem/index.style'
import { Heading3 } from '../../styles/vars/textStyles.style'

export const CarouselWrapper = styled.div``

export const CarouselMain = styled.div`
  -webkit-tap-highlight-color: transparent;
`

export const CarouselHeader = styled.div`
  pointer-events: none;
  position: relative;
  z-index: 2;
`

export const CarouselContainer = styled.div`
  ${clamp('margin-right', -22, -49, breakpoints.mobile, breakpoints.contained)};
  overflow: hidden;
  position: relative;
  z-index: 1;

  ${mq.tabletP} {
    ${props =>
      props.featured
        ? ``
        : `margin-left: calc(100% / ${grid.colCount} - ${getClampValue(
            grid.gap.min,
            grid.gap.max,
            breakpoints.mobile,
            breakpoints.contained
          )} / 2);`}
  }

  ${mq.desk} {
    ${props =>
      props.featured
        ? clamp(
            'margin-top',
            -80,
            -120,
            breakpoints.desk,
            breakpoints.contained,
            true
          )
        : ``}
  }
`

export const CarouselHeading = styled.div`
  pointer-events: all;

  ${Heading3} {
    ${mq.desk} {
      max-width: 37rem;
    }
  }
`

export const CarouselDesktopFeaturedNav = styled.div`
  display: none;

  ${mq.tabletL} {
    display: block;
  }
`

export const CarouselMobileFeaturedNav = styled.div`
  ${mq.tabletL} {
    display: none;
  }
`

export const CarouselTrack = styled.div`
  position: relative;
  width: 84%;

  ${mq.tabletP} {
    ${props =>
      clamp(
        'width',
        props.featured ? 467 : 285,
        props.featured ? 632 : 385,
        breakpoints.tabletP,
        breakpoints.tabletL
      )};

    ${props =>
      props.featured
        ? ``
        : clamp(
            'margin-left',
            grid.gap.min / 2,
            grid.gap.max / 2,
            breakpoints.mobile,
            breakpoints.contained,
            true
          )}
  }

  ${mq.desk} {
    ${props =>
      clamp(
        'width',
        props.featured ? 670 : 375,
        props.featured ? 1054 : 440,
        breakpoints.desk,
        breakpoints.contained,
        true
      )};
  }

  ${CarouselItemMain} {
    height: 100%;
    position: absolute;
    top: 0;

    &:first-child {
      position: relative;
    }
  }
`
